import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { comfortDare } from "./comfortDareAPI";

const initialState = {
    status: "idle",
    NewQuestion: '',
    NewQuestionTimer: '',
    DrinkQuestion: '',
    Attributes: [],
    Accessories: [],
    UsedQuestionsId: [],
    LastCard: false,
}

export const comfortDareAsync = createAsyncThunk(
    "/comfortdare",
    async ({ gender, player}, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const usedid = state.comfortDare.UsedQuestionsId;
            const selectedaccessories = state.comfortDare.Accessories;
            const sessionid = state.gameStatus.sessions['comfort'].sessionId
            
            

            const response = await comfortDare(gender, player, usedid, selectedaccessories, sessionid);
            return response; // ✅ Ensure response is returned properly
        } catch (error) {
            console.error("Error in comfortDareAsync:", error); // 👀 This should appear now
            return rejectWithValue(error.response
                ? { data: error.response.data, status: error.response.status }
                : { data: { error: "Unknown error" }, status: 500 })
        }
    }
);


export const comfortDareSlice = createSlice({
    name: "comfortdare",
    initialState,
    reducers: {
        setAccessories: (state, action) => {
            state.Accessories = action.payload

        },
        resetState: (state) => {
            state.status = "idle";
            state.NewQuestion = '';
            state.NewQuestionTimer = '';
            state.DrinkQuestion = '';
            state.Attributes = [];
            state.Accessories = [];
            state.UsedQuestionsId = [];
            state.LastCard = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(comfortDareAsync.pending, (state) => {
                state.status = 'fetching';
            })
            .addCase(comfortDareAsync.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.NewQuestion = action.payload.question
                state.NewQuestionTimer = action.payload.timer
                state.DrinkQuestion = action.payload.drink
                state.UsedQuestionsId = [...state.UsedQuestionsId, action.payload.id]
                state.Attributes = [action.payload.attributes]
                state.LastCard = action.payload.last_card || false;
            })
    }
})

export const selectComfortDare = (state) => state.comfortDare
export const { setAccessories, resetState } = comfortDareSlice.actions;
export default comfortDareSlice.reducer